module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "takeawayMobile"
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "bodyContent"
  }, [(_vm.takeawayObject) ? _c('div', {
    staticClass: "smallcontainer"
  }, [_c('div', {
    staticClass: "headsmall"
  }, [_c('img', {
    staticClass: "logosl",
    attrs: {
      "alt": "TONE Networks",
      "src": require("../assets/coloredlogotone.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/mytone'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn",
    attrs: {
      "alt": "TONE home",
      "src": require("../assets/TONE_HOME_ICON.png")
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "grad",
    attrs: {
      "alt": "",
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/0a3d90ee-c79e-472c-9bae-1a89539be47c.jpg"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Hey there, " + _vm._s(_vm.takeawayObject.firstName))]), _vm._v(" "), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Thanks for watching!The following TONE Takeaways will help you set the tone of your day.")]), _vm._v(" "), _c('a', {
    staticClass: "lglink",
    attrs: {
      "href": _vm.takeawayObject.video1UrlKey
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(_vm.takeawayObject.video1UrlKey)
      }
    }
  }, [_vm._v(_vm._s(_vm.takeawayObject.video1Key))]), _vm._v(" "), _vm._l((_vm.takeawayObject.tonetakeAways), function(takeaway) {
    return _c('div', {
      staticClass: "listesection"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "briefcasetext"
    }, [_c('h4', [_vm._v("Tone Takeaways:")]), _vm._v(" "), _c('a', {
      staticClass: "brieflink",
      attrs: {
        "href": takeaway.videoURL
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.$router.push(takeaway.videoURL)
        }
      }
    }, [_vm._v(_vm._s(takeaway.vTitle))])])]), _vm._v(" "), (takeaway.tone1) ? _c('div', {
      staticClass: "row listingsection"
    }, [_c('div', {
      staticClass: "listentryholder"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "listingtext"
    }, [_vm._v("\n                            " + _vm._s(takeaway.tone1) + "\n                        ")])]), _vm._v(" "), (takeaway.tone2) ? _c('div', {
      staticClass: "listentryholder"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "listingtext"
    }, [_vm._v("\n                            " + _vm._s(takeaway.tone2) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (takeaway.tone3) ? _c('div', {
      staticClass: "listentryholder"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "listingtext"
    }, [_vm._v("\n                            " + _vm._s(takeaway.tone3) + "\n                        ")])]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), (_vm.takeawayObject.talkTitle || _vm.takeawayObject.expertName) ? _c('div', {
    staticClass: "purpletextcontainer"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Upcoming Events")]), _vm._v(" "), (_vm.takeawayObject.talkTitle) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "alt": _vm.takeawayObject.talkTitle,
      "src": _vm.takeawayObject.talkImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Talk:" + _vm._s(_vm.takeawayObject.talkTitle))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.takeawayObject.talkLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.takeawayObject.talkStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("/event/" + (_vm.takeawayObject.talkEventId))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/event/" + (_vm.takeawayObject.talkEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e(), _vm._v(" "), (_vm.takeawayObject.expertName) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "alt": _vm.takeawayObject.expertName,
      "src": _vm.takeawayObject.eventImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Live: " + _vm._s(_vm.takeawayObject.expertName))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.takeawayObject.eventLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.takeawayObject.eventStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("/event/" + (_vm.takeawayObject.eventEventId))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/event/" + (_vm.takeawayObject.eventEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/mytone'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn lastlogobutton",
    attrs: {
      "alt": "TONE home",
      "src": require("../assets/TONE_HOME_ICON.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "pinktext"
  }, [_vm._v("Set the tone of your life")]), _vm._v(" "), _c('p', {
    staticClass: "lastpara"
  }, [_vm._v("- The TONE Team")])], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "briefcasesection"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/01041c2a-2e73-4ca5-99b9-827c441be3e2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listingimg"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/24ffbbd6-7718-487e-a23d-7f968c64428f.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listingimg"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/b0047950-fa37-44f7-9b0c-2ec540e2b6eb.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listingimg"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/c2bc65aa-8383-4e0f-a6dc-d25fd9828a74.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a428d674", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a428d674"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/TakeawayMobile.vue